import { createApi } from '@reduxjs/toolkit/query/react'

import { baseQuery } from '../../query'
import { ThemeSuggestionsRequest, ThemeSuggestionsResponse } from './types'

export const themeApi = createApi({
  reducerPath: 'theme',
  baseQuery,
  endpoints: (builder) => ({
    generateSuggestions: builder.mutation<
      ThemeSuggestionsResponse,
      ThemeSuggestionsRequest
    >({
      query: (data) => ({
        url: '/api/theme/suggestions',
        method: 'POST',
        body: data,
      }),
    }),
  }),
})

export const { useGenerateSuggestionsMutation } = themeApi
